module.exports = __webpack_public_path__ + "media/images/lb/945-4902d79992795599f0fadc892058d476.svg";